import React, { useState } from "react";
import { TableAdv, TagAdv, Button, SmartTooltip } from "../../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../../utils";

const actionColorMap = {
  Paid: "success",
  Unpaid: "danger",
};

const IncentiveSheet = () => {
  const rows = [
    {
      id: 1,
      name: "Amit Verma",
      client: "Internal",
      invoiceNumber: "BENCH001",
      totalSalary: 280,
      percentage: 10,
      commission: 0,
      startDate: "2026-02-15",
      warrantyPeriod: "0",
      warrantyPeriodEndDate: "-",
      details: [{ role: "RA", name: "Internal HR", amount: 0 }],
    },
    {
      id: 2,
      name: "Priya Das",
      client: "Internal",
      invoiceNumber: "BENCH002",
      totalSalary: 300,
      percentage: 10,
      commission: 0,
      startDate: "2026-03-01",
      warrantyPeriod: "0",
      warrantyPeriodEndDate: "-",
      details: [{ role: "RA", name: "Internal HR", amount: 0 }],
    },
    {
      id: 3,
      name: "Rohit Sharma",
      client: "Internal",
      invoiceNumber: "BENCH003",
      totalSalary: 310,
      percentage: 10,
      commission: 0,
      startDate: "2026-01-20",
      warrantyPeriod: "0",
      warrantyPeriodEndDate: "-",
      details: [{ role: "RA", name: "Internal HR", amount: 0 }],
    },
    {
      id: 4,
      name: "Sneha Gupta",
      client: "Internal",
      invoiceNumber: "BENCH004",
      totalSalary: 290,
      percentage: 10,
      commission: 0,
      startDate: "2026-02-10",
      warrantyPeriod: "0",
      warrantyPeriodEndDate: "-",
      details: [{ role: "RA", name: "Internal HR", amount: 0 }],
    },
    {
      id: 5,
      name: "Vikram Singh",
      client: "Internal",
      invoiceNumber: "BENCH005",
      totalSalary: 350,
      percentage: 10,
      commission: 0,
      startDate: "2026-03-05",
      warrantyPeriod: "0",
      warrantyPeriodEndDate: "-",
      details: [{ role: "RA", name: "Internal HR", amount: 0 }],
    },
    {
      id: 6,
      name: "Ananya Roy",
      client: "Internal",
      invoiceNumber: "BENCH006",
      totalSalary: 250,
      percentage: 10,
      commission: 0,
      startDate: "2026-01-15",
      warrantyPeriod: "0",
      warrantyPeriodEndDate: "-",
      details: [{ role: "RA", name: "Internal HR", amount: 0 }],
    },
    {
      id: 7,
      name: "Karan Johar",
      client: "Internal",
      invoiceNumber: "BENCH007",
      totalSalary: 400,
      percentage: 10,
      commission: 0,
      startDate: "2026-02-28",
      warrantyPeriod: "0",
      warrantyPeriodEndDate: "-",
      details: [{ role: "RA", name: "Internal HR", amount: 0 }],
    },
    {
      id: 8,
      name: "Meera Iyer",
      client: "Internal",
      invoiceNumber: "BENCH008",
      totalSalary: 280,
      percentage: 10,
      commission: 0,
      startDate: "2026-03-10",
      warrantyPeriod: "0",
      warrantyPeriodEndDate: "-",
      details: [{ role: "RA", name: "Internal HR", amount: 0 }],
    },
    {
      id: 9,
      name: "Arjun Rampal",
      client: "Internal",
      invoiceNumber: "BENCH009",
      totalSalary: 330,
      percentage: 10,
      commission: 0,
      startDate: "2026-01-25",
      warrantyPeriod: "0",
      warrantyPeriodEndDate: "-",
      details: [{ role: "RA", name: "Internal HR", amount: 0 }],
    },
    {
      id: 10,
      name: "Nisha Agarwal",
      client: "Internal",
      invoiceNumber: "BENCH010",
      totalSalary: 360,
      percentage: 10,
      commission: 0,
      startDate: "2026-02-05",
      warrantyPeriod: "0",
      warrantyPeriodEndDate: "-",
      details: [{ role: "RA", name: "Internal HR", amount: 0 }],
    },
  ];

  const columns = [
    {
      key: "name",
      label: "Name of Active Consultant",
      render: (row) => (
        <div className="flex items-center gap-2">
          {row.details && (
            <Button
              icon={
                expandedRows[row.id]
                  ? "keyboard_arrow_down"
                  : "keyboard_arrow_right"
              }
              type="icon"
              variant="text"
              size="xs"
              color="black"
              onClick={(e) => {
                e.stopPropagation();
                handleRowToggle(row.id);
              }}
            />
          )}
          {row.name}
        </div>
      ),
    },

    {
      key: "client",
      label: "Client Name",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.client}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.client}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "invoiceNumber",
      label: "Invoice Number",
    },
    {
      key: "totalSalary",
      label: "Total salary ",
      render: (row) => `$${row.totalSalary}`,
    },
    {
      key: "percentage",
      label: "Percentage",
      render: (row) => `${row.percentage}%`,
    },
    {
      key: "commission",
      label: "Commission",
      render: (row) => `$${row.commission}`,
    },
    {
      key: "startDate",
      label: "Start Date",
      render: (row) => dateFormator(row.startDate),
    },
    {
      key: "warrantyPeriod",
      label: "Warranty Period",
      render: (row) => `${row.warrantyPeriod} days`,
    },
    {
      key: "warrantyPeriodEndDate",
      label: "Warranty Period End Date",
      render: (row) => dateFormator(row.warrantyPeriodEndDate),
    },
  ];

  const mappedRows = mapTableRows(rows, columns);
  const [expandedRows, setExpandedRows] = useState({});

  const handleRowToggle = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  const AccordionComponent = ({ row }) => {
    if (!row.details) return null;
    return (
      <div className="bg-[#FFF5EC] p-4 flex flex-col gap-2">
        {/* Grid for items */}
        <div className="flex w-full items-start gap-8">
          <div className="flex flex-col gap-1 min-w-[max-content]">
            <span className="text-xs font-semibold text-gray-500 mt-6 pt-1">
              USD Total
            </span>
          </div>

          {row.details.map((item, idx) => (
            <div key={idx} className="flex flex-col gap-1">
              <span className="text-xs font-semibold text-gray-700 whitespace-nowrap">
                {item.role}{" "}
                <span className="text-gray-500 font-normal">({item.name})</span>
              </span>
              <span className="text-sm font-medium text-gray-900">
                {item.amount !== null ? `$${item.amount}` : ""}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="h-full flex-1 w-full flex flex-col overflow-hidden">
      <TableAdv
        columns={columns}
        rows={mappedRows}
        toolbarRight={{ search: true }}
        accordion={<AccordionComponent />}
        expandedRows={expandedRows}
        onRowToggle={handleRowToggle}
      />
    </div>
  );
};

export default IncentiveSheet;
